export default "__VITE_ASSET__EcT8VQlS__"